module.exports = __webpack_public_path__ + "static/pe4-891084b3961046250a3f6af3eae70494.png";